var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { staticClass: "iframe-wrap" },
    [
      _c(
        "w-card-title",
        [
          _c("w-tabs", {
            attrs: { tabs: _vm.documentTabs },
            model: {
              value: _vm.documentTab,
              callback: function ($$v) {
                _vm.documentTab = $$v
              },
              expression: "documentTab",
            },
          }),
          _c("w-spacer"),
          _vm._t("action-buttons"),
        ],
        2
      ),
      _c(
        "w-card-content",
        {
          staticClass: "iframe-wrap content-wrap",
          style: { padding: "0 0 0 0" },
        },
        [
          _vm.currentFileIsOriginal
            ? _c(
                "w-chip",
                { staticClass: "original-chip" },
                [
                  _c("w-fa", { staticClass: "mrs", attrs: { icon: "star" } }),
                  _vm._v(" " + _vm._s(_vm.$ct("original-invoice")) + " "),
                ],
                1
              )
            : _vm._e(),
          !_vm.previewOnly && _vm.documentTab == 0
            ? _c("app-aws-files-edit", {
                attrs: {
                  files: _vm.value.Documents,
                  "to-add-files": _vm.value.UnprocessedFiles,
                  "to-remove-files": _vm.value.ToDeleteFiles,
                  "allow-mark-original": "",
                },
                on: { "mark-original": _vm.onMarkOriginal },
              })
            : _vm._e(),
          _vm._l(_vm.fileList, function (file, i) {
            return [
              _vm.isXmlFile(file) && _vm.peppolOrder
                ? _c("app-order-preview-content", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.documentTab - _vm.tabOffset == i,
                        expression: "documentTab - tabOffset == i",
                      },
                    ],
                    key: "order-" + file.key,
                    attrs: { order: _vm.peppolOrder },
                  })
                : file.url && !(_vm.isXmlFile(file) && _vm.loadingPeppolOrder)
                ? _c("iframe", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.documentTab - _vm.tabOffset == i,
                        expression: "documentTab - tabOffset == i",
                      },
                    ],
                    key: "iframe-" + file.key,
                    staticClass: "iframe",
                    attrs: { src: file.url + "#navpanes=0", frameborder: "0" },
                  })
                : _vm._e(),
            ]
          }),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }